import { ActionTypes } from './actionTypes';
import { AppDispatch } from '../store';
import { createAction } from '../actions';

export const saveRegionsInfo = (regionsInfo: string[]) => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SAVE, regionsInfo));
};
